/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module AnalyticsModule */

import { Injector } from '@angular/core';

import {
    AnalyticsProfileCollection,
} from 'ajs/modules/analytics/factories/analytics-profile.collection.factory';

import { ANALYTICS_PROFILE_COLLECTION_TOKEN } from 'ajs/modules/analytics/analytics.tokens';

const $injector = '$injector';

export const analyticsProfileCollectionProvider = {
    deps: [$injector],
    provide: AnalyticsProfileCollection,
    useFactory(injector: Injector): typeof AnalyticsProfileCollection {
        return injector.get(ANALYTICS_PROFILE_COLLECTION_TOKEN);
    },
};
